export default {
  meta: {
    'key-content': 'Llamada de voz gratuita, comunicación segura, mensajería instantánea, grabación después de leer, mensaje seguro',
    'description-content': 'Crait es una herramienta segura de mensajería y colaboración diseñada para que las empresas aumenten su productividad. Los datos de la empresa están protegidos de la vigilancia o la violación de datos porque los datos se transportan a través de un canal encriptado de nivel militar.',
    'h-m-title': 'Crait | Su plataforma de comunicación segura'
  },
  head: {
    'home': 'Inicio',
    'features': 'Features',
    'pricing': 'Precio',
    'recursos': 'Recursos',
    'openapi': 'Abrir API',
    'contact': 'Contact',
    'descargar': 'Descargar',
    'login': 'Iniciar sesión',
    'console': 'Consola',
    'CraitForWeb': 'Crait para web '
  },
  home: {
    'title1': 'Comunicación segura',
    'title2': 'Para todo el mundo',
    'subtitle': 'Chats seguros · Leer y grabar · Audio y videollamadas gratis',
    'placeholder': 'Correo electrónico, teléfono o nombre de usuario',
    'getstart': 'Comenzar',
    'contitle': 'Crait Advantage',
    'intro1-title': 'Chats de apoyo con hasta 1000 personas',
    'intro1-detail': 'Soporte para crear grupos de 1000 personas y llamadas de conferencia de múltiples personas, todos los mensajes, imágenes y videos están protegidos por encriptación de extremo a extremo.',
    'intro2-title': 'Secure Communication',
    'intro2-detail': 'El cifrado de extremo a extremo AES de 256 bits estándar de la industria se adopta en todas las plataformas. Para evitar cualquier posible ataque man-in-the-middle y garantizar la seguridad de los datos, todas las comunicaciones pasan por Transport Layer Security (TLS).',
    'intro3-title': 'Optimización de la gestión de la organización',
    'intro3-detail': 'Con control administrativo, la estructura organizacional se puede construir en el software, y los empleados pueden ser autorizados a diferentes capas de datos.',
    'intro4-title': 'Diseñado para la eficiencia',
    'intro4-detail': 'Secure Mail y el cifrado Cloud Drive garantizan la seguridad de los datos; El calendario configura elementos pendientes y mejora la eficiencia del trabajo',
    'keyfeature-title': 'Funciones clave',
    'keyfeature-list1': 'Secure Chats',
    'keyfeature-list2': 'Secure Audio Calls',
    'keyfeature-list3': 'Uso compartido seguro de archivos',
    'keyfeature-list4': 'Sincronizado en todas las plataformas',
    'keyfeature-list5': 'Mensajes de voz',
    'keyfeature-list6': 'Secure Cloud Drive',
    'learnmore': 'Aprender más',
    'download-title': 'Disponible para descargar en todas las plataformas populares',
    'download-detail': 'Crait es donde los grupos de trabajo se comunican y colaboran de forma segura. Es una herramienta de mensajería segura diseñada para hacer que la vida laboral sea más eficiente y productiva. Disponible en varias plataformas, sus mensajes y datos se pueden sincronizar entre todos sus dispositivos.',
    'err-tip-email': 'Lo sentimos, pero el correo electrónico no es válido',
    'err-tip-phone': 'Lo sentimos, pero el número de teléfono no es válido',
    'click': 'Toque',
    'wx-tip1': 'el icono en la esquina superior derecha',
    'select': 'Haga clic en',
    'wx-tip2': 'para abrir en el navegador'
  },
  features: {
    'f-title': 'Herramienta de mensajería segura diseñada para facilitar la vida labora.',
    'feature-title': 'Comunicación segura',
    'feature-list1-title': 'Secure Chats',
    'feature-list1-detail': '1 a 1 chat y chat en grupo de hasta 1000 usuarios. Reenviar, recuperar y eliminar opciones de mensaje disponibles.',
    'feature-list2-title': 'Secure Audio Calls',
    'feature-list2-detail': '1 a 1 llamadas de audio y llamadas de audio grupales hasta 20 usuarios. La función de silencio está disponible para silenciar el ruido de fondo.',
    'feature-list3-title': 'Conference Call',
    'feature-list3-detail': 'Disfrute de conferencias encriptadas de extremo a extremo con auto-spotlight, para hasta 20 usuarios. La función de autoenfoque amplifica la voz del altavoz principal, junto con la función de cancelación de ruido.',
    'feature-list4-title': 'Sincronizado en todas las plataformas',
    'feature-list4-detail': 'Disponible para todas las plataformas principales.',
    'feature-list5-title': 'Notas de voz',
    'feature-list5-detail': 'Toque para grabar un mensaje de voz y suéltelo para finalizar la grabación y el envío.',
    'feature-list6-title': 'Uso compartido seguro de archivos',
    'feature-list6-detail': 'Casi todos los tipos de archivos son compatibles, incluidos PDF, DOC, XLS, etc. Se pueden compartir documentos de hasta 100 MB, y los grupos de trabajo pueden colaborar juntos en el documento.',
    'feature-list7-title': 'Secure Cloud Drive',
    'feature-list7-detail': 'Unidad personal segura, basada en la nube, que le proporciona acceso a documentos sobre la marcha sin llevar ningún dispositivo físico.',
    'feature-list8-title': 'Broadcast',
    'feature-list8-detail': 'Las transmisiones son avisos diseminados a miembros preseleccionados de un grupo de trabajo. Las transmisiones se entregan y reciben a la vez. Esta característica es útil para ahorrar tiempo y puede ser muy útil para tratar asuntos urgentes.',
    'feature-list9-title': 'Security',
    'feature-list9-detail': 'Configuración de grabación y lectura, ajuste de lectura de lectura y funciones de protección de pantalla incorporadas en la plataforma.',
    'other-feature': 'Other Features',
    'other-list1-title': 'Aplicaciones de plug-in personalizables',
    'other-list1-detail': 'Las aplicaciones de complemento se pueden personalizar de acuerdo con las necesidades de su industria o las necesidades específicas de la compañía. Desde el intercambio de calendario en equipo, la reserva de salas de reuniones hasta la administración de suministros de oficina, estas aplicaciones serán la herramienta de comunicación para ayudarlo a mejorar la eficiencia y la productividad del trabajo.',
    'other-list2-title': 'Buscar',
    'other-list2-detail': 'Buscar a través de hilos de mensajes para encontrar mensajes antiguos. Encuentre fácilmente contactos buscando con sus direcciones de correo electrónico o si tiene privilegios especiales de chat grupal, asignados por un administrador, busque contactos en los equipos.'
  },
  pricing: {
    'p-title1': 'Funciones',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': 'Unlimted',
    'tr1-td1': 'El número máximo de grupos permite crear',
    'tr2-td1': 'Número máximo de miembros del grupo',
    'tr3-td1': 'Número máximo de destinatarios de mensajes de difusión',
    'tr4-td1': 'Número máximo de miembros de la conferencia',
    'tr5-td1': 'Espacio en la nube para el grupo',
    'tr6-td1': 'Espacio en la nube para personal',
    'tr7-td1': 'Video llamada',
    'tr8-td1': 'Lista de plug-ins',
    'tr8-td2': 'Solo demostraciones de servidor',
    'tr8-td3': 'Cargado por cada plug-in',
    'tr9-td1': 'Servicio al cliente y soporte técnico',
    'tr9-td2': 'En la aplicación de soporte',
    'tr9-td3': '7x24h (correo o teléfono)',
    'tr10-td1': 'Proporciona el sitio web o la aplicación del Team Manager',
    'tr11-td1': 'Admite todas las plataformas',
    'tr12-td1': 'Precio',
    'tr12-td2': 'Libre',
    'tr12-td3': '$ 2.99 por mes',
    'btn1': 'Comenzar',
    'btn2': 'Actualizar ahora'
  },
  resources: {
    'readmore1': 'LEER MÁS -',
    'readmore2': 'Leer más',
    'r-title1': 'Libro blanco',
    'r-title2': 'Blogs',
    'subtitle1': '¿QUÉ ES CRAIT?',
    'detail1': 'Crait es donde ocurre la comunicación segura y la colaboración. Es una herramienta de mensajería segura diseñada para hacer que la vida laboral sea más fácil y más productiva para los grupos de trabajo ...',
    'subtitle2': 'Tendencias de incumplimiento de datos',
    'detail2': 'Las infracciones de datos no son buenas. Será útil para las compañías reexaminar su seguridad básica de seguridad con una visión deliberada de fortalecer sus respectivas posturas de seguridad ...',
    'subtitle3': 'Las pequeñas empresas son objetivos fáciles',
    'detail3': 'No todas las ideas de sentido común contienen agua. Un ejemplo de una idea común que no coincide con la realidad es la noción de que los piratas informáticos solo se dirigen a las grandes empresas. El creciente número de ciberataques en pequeñas empresas contradice fuertemente este sentimiento aparentemente prevalente de que las pequeñas empresas no son objeto de ataques ilegales. Examinemos los hechos ...'
  },
  contact: {
    'c-title1': 'Gracias por su interés en la plataforma de comunicación segura Crait',
    'c-title2': 'por favor díganos más acerca de su empresa y nuestro equipo de ventas estará en contacto en breve',
    'firstname': 'Nombre *',
    'lastname': 'Last Name *',
    'workemail': 'Correo electrónico de trabajo *',
    'phone': 'Phone Number *',
    'compañía': 'Nombre de la compañía *',
    'size': 'Tamaño de la empresa *',
    'location': 'Location',
    'industry': 'Industry',
    'send': 'Send',
    'emaillabel': 'Correo electrónico:',
    'email': 'info@craitapp.com'
  },
  download: {
    'intro': 'Crait es donde los grupos de trabajo se comunican y colaboran de forma segura. Es una herramienta de mensajería segura diseñada para hacer que la vida laboral sea más eficiente y productiva. Disponible en varias plataformas, sus mensajes y datos se pueden sincronizar entre todos sus dispositivos.',
    'd-title': 'Disponible para descargar en todas las plataformas populares',
    'sub-intro1': 'Para instalar Crait, escanee el QR a continuación o haga clic en los botones a continuación.',
    'sub-intro2': 'También puede iniciar sesión en Crait para acceder a la versión web',
    'home-download-title1': 'Equipo de Gestión para Empresas',
    'home-download-title2': 'Diseño Organizacional Eficiente',
    'home-download-title3': 'Correo',
    'home-download-title4': 'Llamadas de conferencia',
    'home-download-title5': 'Ir a crait para web',
    'home-download-title6': 'Descargar crait para PC',
    'home-download-title7': 'Trate de crait ahora',
    'home-download-title8': 'Cloud Drive',
    'download-getApp': 'Obtener la aplicación para ',
    'download-iphone': 'iPhone',
    'download-scanCode': 'Aplicación de descarga',
    'download-dlApp': 'de código de escaneo',
    'download-gphone': 'Android',
    'download-pc': 'PC',
    'download-chrome': 'Chrome',
    'download-title-m': 'Colaboración sin límites',
    'download-dl-btn': 'Empezar'
  },
  payment: {
    'prices-payment-title1': 'Cuenta a ser actualizado',
    'prices-payment-title2': 'La cuenta que desea actualizar a crait pro',
    'prices-payment-title3': 'El plan que desea comprar',
    'prices-payment-title4': 'Por favor, seleccione',
    'prices-payment-title5': 'Total',
    'prices-payment-title6': 'Pago',
    'prices-payment-title7': 'PayPal',
    'prices-payment-title8': 'Pagar ahora',
    'prices-payment-title9': 'La actualización a crait pro significa que usted acepta los siguientes términos y condiciones',
    'prices-payment-title10': 'Crait pagado acuerdo de usuario',
    'prices-payment-title11': 'Política de privacidad',
    'prices-payment-title12': '¡Error de red!',
    'prices-payment-title13': 'Por favor, introduzca una cuenta registrada crait'
  },
  confirm: {
    'prices-confirm-title1': 'Cuenta a ser actualizado',
    'prices-confirm-title2': 'Plan elegido',
    'prices-confirm-title3': 'Total',
    'prices-confirm-title4': 'Pago',
    'prices-confirm-title5': 'Hacer el pago',
    'prices-confirm-title6': 'Ir a la pagina de pago de terceros...',
    'prices-confirm-title7': 'Por favor realizar el pago en la pagina de terceros',
    'prices-confirm-title8': 'No pagan',
    'prices-confirm-title9': 'Pago realizado',
    'prices-confirm-title10': '¡Error de red!'
  },
  success: {
    'prices-success-title1': 'Tu cuenta ha sido actualizado a crait pro',
    'prices-success-title2': 'Tu cuenta sera * upgraded a crait pro una vez confirmado el pago',
    'prices-success-title3': 'Upgraded cuenta:',
    'prices-success-title4': 'Plan comprado'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/spa.js